import React from 'react';
import {CollapseFilter} from 'components/partials/collapse';
import style from './style.scss';
import Slider from 'rc-slider';
const Range = Slider.Range;

class PriceFilter extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      min: 0,
      max: 150000,
      minPrice: 20000,
      maxPrice: 50000,
    }
  }

  onChange(name, e) {
    if(name == 'minPrice' && Number(e.target.value) > this.state.maxPrice) {
      this.setState({
        [name]: Number(this.state.maxPrice)
      })
    } else if(name == 'maxPrice' && Number(e.target.value) < this.state.minPrice) {
      this.setState({
        [name]: Number(this.state.minPrice)
      })
    } else {
      this.setState({
        [name]: Number(e.target.value)
      })
    }
  }

  onSliderChange(e) {
    this.setState({
      minPrice: e[0],
      maxPrice: e[1]
    })
  }

  render() {
    return (
      <section className="price-filter">
        <CollapseFilter value={true} title='GIÁ'>
          <div className='range-wrap'>
            <Range value={[this.state.minPrice, this.state.maxPrice]} min={this.state.min} max={this.state.max} onChange={this.onSliderChange.bind(this)}/>
          </div>
          <div className='wrap-input content-justify'>
            <input className='price-input' value={this.state.minPrice} onChange={this.onChange.bind(this, 'minPrice')}/>
            <span className='line-center'>-</span>
            <input className='price-input' value={this.state.maxPrice} onChange={this.onChange.bind(this, 'maxPrice')}/>
          </div>
        </CollapseFilter>
      </section>
    );
  }
}

export default PriceFilter;


// WEBPACK FOOTER //
// ./components/list-product/list-filter/sub-filter/PriceFilter.jsx